window._ = require('lodash');
window.Swal = require('sweetalert2');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
window.tippy = require('tippy.js').default;

// Tabler includes Bootstrap 5.3.7 bundled - do NOT load bootstrap separately
const tabler = require('@tabler/core/dist/js/tabler');
window.bootstrap = tabler;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.toastr = require('toastr');


window.toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-bottom-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "6000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  }

if(document.getElementById('MunkarendCalContainer')) {
    const munkarend = require('./frontend/parts/munkarend/munkarend');
    window.munkarend = munkarend;
    window.munkarend.munkarend.init();
}

if(document.getElementById('CarUtilizationCalContainer')) {
    const carUtilization = require('./frontend/parts/munkarend/car-utilization');
    window.carUtilization = carUtilization;
    window.carUtilization.carUtilization.init();
}

if(document.getElementById('jelentesBody')) {
    const jelentes = require('./frontend/parts/munkarend/jelentes');
    window.jelentes = jelentes;
    window.jelentes.jelentes.init();
}

const dlist = document.querySelector('#formHolder fieldset:nth-of-type(2)');
if(dlist) {
    dlist.classList.add('d-flex');
    dlist.classList.add('mt-4');
}


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


import Webpass from "@laragear/webpass/dist/webpass.mjs";




const initWpass = async () => {
    try {
        const webpass = Webpass.create({
            retry: 3,
            retryDelay: 500,
            onResponse: ({ response }) => console.debug(response),
            findCsrfToken: true,
        })

        const { user, success, error } = await webpass.assert("/webauthn/login/options", "/webauthn/login")

        //const { success } = await Webpass.attest("/webauthn/register/options", "/webauthn/register");
        if (success) {
            window.location.replace("/account");
        } else {
            Swal.fire({
                title: "Hiba!",
                html: `A bejelentkezés nem sikerült: ${error.message}<br />Ellenőrizze hogy a publikus kulcs létezik-e a fiókjában, és érvényes-e.<br />Használjon másik kulcsot, vagy a jelszavát a bejelentkezéshez.`,
                icon: "error",
                confirmButtonText: "OK"
            });

        }
    } catch (error) {
        console.error("Registration failed:", error);
    }
}

const regWpass = async () => {
    try {
        const webpass = Webpass.create({
            retry: 3,
            retryDelay: 500,
            onResponse: ({ response }) => console.debug(response),
            findCsrfToken: true,
        })

        const { success } = await Webpass.attest("/webauthn/register/options", "/webauthn/register");
        if (success) {
            Swal.fire("Létrehozva!", "Az új kulcs sikeresen létrejött. Kijelentkezés után használhatja.", "success").then(() => {
                location.reload(); // Refresh the page to update the table
            });
        } else {
            Swal.fire("Hiba!", "A kulcs létrehozása nem sikerült. Próbálja újra.", "error");
        }
    } catch (error) {
        console.error("Registration failed:", error);
    }
}

const bioLopginBtn = document.querySelector("#myLoginB");
const bioRegBtn = document.querySelector("#addBioLogin");

if(bioLopginBtn) {
    bioLopginBtn.addEventListener("click", initWpass);
}

if(bioRegBtn) {
    bioRegBtn.addEventListener("click", regWpass);
}
